import { Typography } from '@mui/material';
import colors from './colors';

export type TextProps = {
  children: string | React.ReactNode
  weight?: 'bold'
  size?: 'title' | 'body1' | 'body2' | 'subtitle'
  align?: 'left' | 'right' | 'center'
  color?: keyof typeof colors
  truncate?: boolean
};

const styles: Record<NonNullable<TextProps['size']>, { size: number }> = {
  title: { size: 20 },
  subtitle: { size: 14 },
  body1: { size: 12 },
  body2: { size: 10 },
};

export const TextUI: React.FC<TextProps> = ({ children, weight, size = 'body1', align, color = 'black', truncate }) => {
  const style = styles[size];
  const overflowStyle = truncate ? { textOverflow: 'ellipsis', overflow: 'hidden' } : {};
  return (
    <Typography {...overflowStyle} variantMapping={{ body1: 'span', body2: 'span' }} fontWeight={weight} fontSize={style.size} align={align} sx={{ color: colors[color] }}>
      {children}
    </Typography>
  );
};
